import { render, staticRenderFns } from "./info-scroll.vue?vue&type=template&id=528b46cf&scoped=true"
import script from "./info-scroll.vue?vue&type=script&lang=js"
export * from "./info-scroll.vue?vue&type=script&lang=js"
import style0 from "./info-scroll.vue?vue&type=style&index=0&id=528b46cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b46cf",
  null
  
)

export default component.exports